/*/////////////FAQアコーディオン/////////////*/
/* 2026-10-16 NNine：使われていなかった「FAQ非表示」の処理を削除（存在しない要素「.#yes」を指定していて、毎回エラーになっていた） */

$(function () {
  $(".a__item").css("display", "none");

  $(".q__item").click(function () {

    $(".q__item").not(this).removeClass("open");

    $(".q__item").not(this).next().slideUp(300);

    $(this).toggleClass("open");

    $(this).next().slideToggle(300);
  });
});